module.exports = __webpack_public_path__ + "static/media/version.565f13fa.svg";